"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.match");

var _waves = _interopRequireDefault(require("@/directive/waves"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _lang = _interopRequireDefault(require("@/lang"));

var _qrcodejs = _interopRequireDefault(require("qrcodejs2"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// waves directive
// import Pagination from '@/components/Pagination' // secondary package based on el-pagination
var _default = {
  name: 'account:bindGoogle',
  extends: _PermissionPage.default,
  components: {
    PermissionSimplePage: _PermissionSimplePage.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      list: null,
      googleCodeTemp: {
        googleVerifyCode: null,
        payPassword: null,
        googleKey: null
      }
    };
  },
  created: function created() {
    this.$store.getters.isAgent ? this.getQrcodeDataInAgent() : this.$store.getters.isMerchant ? this.getQrcodeDataInMerchant() : null;
  },
  computed: {
    errorInfo: function errorInfo() {
      return {
        emptyGoogleVerifyCode: this.$t('SMS.googleVerifyCode') + this.$t('SMS.canNotBeEmpty'),
        emptyPayPassword: this.$t('SMS.payPassword') + this.$t('SMS.canNotBeEmpty'),
        emptyLoginPassword: this.$t('SMS.loginPassword') + this.$t('SMS.canNotBeEmpty'),
        emptyConfirmPassword: this.$t('SMS.confirmPassword') + this.$t('SMS.canNotBeEmpty'),
        invalidPasswordLength: this.$t('message.organizationManagementMessage13'),
        invalidPasswordFormat: this.$t('warningMessage.passwordFormatNoUpperMessage'),
        organizationManagementMessage14: this.$t("message.organizationManagementMessage14")
      };
    },
    rules: function rules() {
      var _this = this;

      var checkGoogleVerifyCode = function checkGoogleVerifyCode(rule, value, callback) {
        if (!value) {
          return callback(new Error(_this.errorInfo.emptyGoogleVerifyCode));
        }

        return callback();
      };

      var checkPayPassword = function checkPayPassword(rule, value, callback) {
        var length;
        var minlength = 8;
        var maxlength = 20;

        if (!value) {
          return callback(new Error(_this.errorInfo.emptyPayPassword));
        }

        length = value.length;

        if (length < minlength || length > maxlength) {
          return callback(new Error(_this.errorInfo.invalidPasswordLength));
        }

        if (!value.match(/[A-Z]/g)) {
          return callback(new Error(_this.errorInfo.invalidPasswordFormat));
        }

        return callback();
      };

      var checkLoginPassword = function checkLoginPassword(rule, value, callback) {
        var length;
        var minlength = 8;
        var maxlength = 20;

        if (!value) {
          return callback(new Error(_this.errorInfo.emptyLoginPassword));
        }

        length = value.length;

        if (length < minlength || length > maxlength) {
          return callback(new Error(_this.errorInfo.invalidPasswordLength));
        }

        if (!value.match(/[A-Z]/g)) {
          return callback(new Error(_this.errorInfo.invalidPasswordFormat));
        }

        return callback();
      };

      return {
        googleVerifyCode: [{
          required: true,
          validator: checkGoogleVerifyCode,
          trigger: 'blur'
        }],
        payPassword: [{
          required: true,
          validator: checkPayPassword,
          trigger: 'blur'
        }],
        password: [{
          required: true,
          validator: checkLoginPassword,
          trigger: 'blur'
        }]
      };
    }
  },
  methods: {
    doResetTemp: function doResetTemp() {
      this.googleCodeTemp = {
        payPassword: null,
        googleKey: null
      };
    },
    doUpdatePasswordForAgent: function doUpdatePasswordForAgent() {
      var _this2 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          _httpUtils.default.post("agentUser", "bindGoogle", null, _this2.googleCodeTemp).then(function (res) {
            if (res.code === 200) {
              _this2.$notify({
                title: _lang.default.t('message.message66'),
                message: res.data,
                type: 'success',
                duration: 2000
              });

              setTimeout(function () {
                _this2.doResetTemp();
              }, 1 * 1000);
            }

            ;

            if (res.code === 500) {
              _this2.$notify({
                title: _lang.default.t('message.message42'),
                message: res.message,
                type: 'error',
                duration: 2000
              });
            }
          }).catch(function (e) {
            _this2.$notify({
              title: _lang.default.t('SMS.alarm'),
              message: _lang.default.t('message.message42') + ',' + e.message,
              type: 'warning',
              duration: 2000
            });
          });
        }
      });
    },
    doUpdatePasswordForMerchant: function doUpdatePasswordForMerchant() {
      var _this3 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          _httpUtils.default.post("organizationUser", "bindGoogle", null, _this3.googleCodeTemp).then(function (res) {
            if (res.code === 200) {
              _this3.$notify({
                title: _lang.default.t('message.message66'),
                message: res.data,
                type: 'success',
                duration: 2000
              });

              setTimeout(function () {
                _this3.doResetTemp();
              }, 1 * 1000);
            }

            ;

            if (res.code === 500) {
              _this3.$notify({
                title: _lang.default.t('message.message42'),
                message: res.message,
                type: 'error',
                duration: 2000
              });
            }
          }).catch(function (err) {
            _this3.$notify({
              title: _lang.default.t('SMS.alarm'),
              message: _lang.default.t('message.message42') + ',' + err.message,
              type: 'warning',
              duration: 2000
            });
          });
        }
      });
    },
    getQrcodeDataInAgent: function getQrcodeDataInAgent() {
      var _this4 = this;

      _httpUtils.default.post("agentUser", "getBindQrCode", null, {}).then(function (res) {
        _this4.googleCodeTemp.googleKey = res.data.googleKey;

        if (res.data.googleQrcode != "null") {
          _this4.qrcode(res.data.googleQrcode);
        } else {
          document.getElementById("qrcode").innerHTML = _lang.default.t('SMS.unboundVerificationCode');
        }
      }).catch(function (err) {
        _this4.$notify({
          title: _this4.$t("common.error"),
          message: _this4.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });
      });
    },
    getQrcodeDataInMerchant: function getQrcodeDataInMerchant() {
      var _this5 = this;

      _httpUtils.default.post("organizationUser", "getBindQrCode", null, {}).then(function (res) {
        _this5.googleCodeTemp.googleKey = res.data.googleKey;

        if (res.data.googleQrcode != "null") {
          _this5.qrcode(res.data.googleQrcode);
        } else {
          document.getElementById("qrcode").innerHTML = _lang.default.t('SMS.unboundVerificationCode');
        }
      }).catch(function (err) {
        _this5.$notify({
          title: _this5.$t("common.error"),
          message: _this5.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });
      });
    },
    qrcode: function qrcode(link) {
      document.getElementById("qrcode").innerHTML = "";
      var that = this;
      var qrcode = new _qrcodejs.default('qrcode', {
        width: 250,
        height: 250,
        // 高度
        text: link // 二维码内容
        // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // backgrounds: '#f0f',   // 背景色
        // foreground: '#ff0'    // 前景色

      });
    }
  }
};
exports.default = _default;